import { useEffect } from "react";
import { NotificationsPresentational } from "./NotificationsPresentation";
import { useNotificationStore } from "./notification-store";

type TProps = {
  className?: string;
  showTopN?: number | null;
};

export const NotificationsContainer = (props: TProps) => {
  const notifications = useNotificationStore((state) => state.notifications);
  const dismissNotification = useNotificationStore((state) => state.dismissNotification);

  useEffect(() => console.log("notifications", notifications), [notifications.length]);

  return (
    <NotificationsPresentational
      className={props.className}
      showTopN={props.showTopN}
      notifications={notifications}
      dismiss={dismissNotification}
    />
  );
};
